import { Action } from 'redux';

import { IMetricInfo } from '../../../ts/models/IMetricInfo';
import { HideMetricsBanner, ResumeMetric, ResumeMetricFromExplorer, UpdateMetricsData, UpdateMetricsDataSucceeded } from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface UpdateMetricsDataAction extends Action {
  metrics: IMetricInfo[];
}

export function updateMetricsData(metrics: IMetricInfo[]): UpdateMetricsDataAction {
  return {
    type: UpdateMetricsData,
    metrics
  };
}

export interface UpdateMetricsDataSucceededAction extends Action {
  readonly metrics: ReadonlyArray<IMetricInfo>;
}

export function updateMetricsDataSucceeded(metrics: ReadonlyArray<IMetricInfo>): UpdateMetricsDataSucceededAction {
  return {
    type: UpdateMetricsDataSucceeded,
    metrics
  };
}

export interface ResumeMetricAction extends Action {
  metric: IMetricInfo;
}

export function resumeMetric(metric: IMetricInfo): ResumeMetricAction {
  return {
    type: ResumeMetric,
    metric
  };
}

export interface ResumeMetricFromExplorerAction extends Action {
  metricId: string;
}

export function resumeMetricFromExplorer(metricId: string): ResumeMetricFromExplorerAction {
  return {
    type: ResumeMetricFromExplorer,
    metricId
  };
}

export interface HideMetricsBannerAction {}

export function hideMetricsBanner(): HideMetricsBannerAction {
  return {
    type: HideMetricsBanner,
  };
}

export const isUpdateMetricsDataSucceededAction = isActionFactory<UpdateMetricsDataSucceededAction>(UpdateMetricsDataSucceeded);
